import React from 'react';
import { FILTER_CONFIG_NAMES, FILTER_FIELD_TYPE } from './DataConstants';
import { FILTER_OPTIONS_IS_AND_IS_NOT } from './FilterUtils';
import { fetchWithDifferntSearchName } from './DataAccessUtils';
import { renderEquipmenTypeSelect } from '../components/purchase_order_form/ReplaceEquipmentLineItemModal';
import OWAsyncSelect from '../components/ow_async_select/OWAsyncSelect';
import { EPSL_CONDITION_DP_FILTERS } from './InventoryUtils';

export const getEquipmentFilterConfig = ({
	stockLocations,
	fetchStockLocations,
	fetchMultipleStockLocations,
	equipmentTypes,
	fetchEquipmentTypes,
	fetchMultipleEquipments,
	assetTypes,
	fetchAssetTypes,
	fetchMultipleAssetTypes,
	vendors,
	fetchVendors,
	fetchMultipleVendors,
	targetCollectionName,
}) => {
	return [
		{
			label: 'Stock Location',
			fieldName: 'stockLocationIds',
			mode: 'multiple',
			stateSlice: stockLocations,
			targetCollectionName,
			fetch: fetchStockLocations,
			fetchMultiple: fetchMultipleStockLocations,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
		{
			label: 'Equipment Type',
			mode: 'multiple',
			fieldName: 'equipmentTypeIds',
			stateSlice: equipmentTypes,
			targetCollectionName,
			fetch: fetchWithDifferntSearchName(fetchEquipmentTypes, 'search'),
			fetchMultiple: fetchMultipleEquipments,
			renderRecord: renderEquipmenTypeSelect,
			labelAccessor: (et) => et.modelName,
			component: OWAsyncSelect,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
		{
			label: 'Asset Type',
			fieldName: FILTER_CONFIG_NAMES.ASSET_TYPE,
			mode: 'multiple',
			stateSlice: assetTypes,
			targetCollectionName,
			fetch: fetchAssetTypes,
			fetchMultiple: fetchMultipleAssetTypes,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
		{
			label: 'Default Vendor',
			fieldName: 'defaultVendorIds',
			mode: 'multiple',
			stateSlice: vendors,
			targetCollectionName,
			fetch: fetchVendors,
			fetchMultiple: fetchMultipleVendors,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
		{
			fieldName: 'isRental',
			type: FILTER_FIELD_TYPE.RADIO_GROUP,
			items: [
				{ label: 'All', value: 'undefined' },
				{ label: 'Rented', value: 'true' },
			],
			defaultValue: undefined,
		},
		...EPSL_CONDITION_DP_FILTERS.map((filter) => ({
			...filter,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		})),
		{
			fieldName: 'isDisbursed',
			type: FILTER_FIELD_TYPE.RADIO_GROUP,
			items: [
				{ label: 'All', value: 'undefined' },
				{ label: 'Not Disbursed', value: 'false' },
				{ label: 'Disbursed', value: 'true' },
			],
			defaultValue: undefined,
		},
	];
};
